<template>
	<label class="file-picker" for="file-picker" @click="onAccessibleClick">
		<slot />
		<input
			id="file-picker"
			type="file"
			@change="onChange"
			:multiple="multiple"
			:accept="accept"
			ref="input"
	/></label>
</template>

<script>
export default {
	name: 'FilePicker',
	props: {
		multiple: {
			type: Boolean,
			default: false,
		},
		accept: {
			type: String,
			default: '*/*',
		},
	},
	emits: ['file-error', 'files'],
	expose: ['openPicker'],
	methods: {
		onChange(e) {
			const { files = [] } = e.target
			const [first] = files
			if (!first) return
			if (!first.type && first.size === 0) {
				this.$emit('file-error', 'Sorry, folders are not supported')
				return
			}
			if (first.size === 0) {
				this.$emit('file-error', 'Sorry, empty files are not supported')
				return
			}
			this.$emit('files', files)
		},
		onAccessibleClick() {
			if (this.accessibilityMode) {
				this.$refs.input.click()
			}
		},
		openPicker() {
			this.$refs.input?.click()
		},
	},
}
</script>

<style lang="scss" scoped>
.file-picker {
	position: relative;
	cursor: pointer;
	overflow: hidden;
	> input {
		display: none;
	}
}
</style>
